import CargoCompanyDispatchMultiListRequest from "../../../../api/raily/cargo-company/dispatch/multi-list/cargo-company-dispatch-multi-list.request";
import paginationService from "../../../../utils/pagination/pagination.service";
import CargoCompanyDispatchMultiListParams from "./cargo-company-dispatch-multi-list-params";

const create = (
  params: CargoCompanyDispatchMultiListParams,
): CargoCompanyDispatchMultiListRequest => {
  return {
    companyIds: params.cargoCompanyUuids,
    limit: params.pageSize,
    offset:
      params.page && params.pageSize
        ? paginationService.calculateOffset(params.page, params.pageSize)
        : undefined,
  };
};

const cargoCompanyDispatchMultiListParamsFactory = {
  create,
};

export default cargoCompanyDispatchMultiListParamsFactory;
